<template>
  <div class="aoform__shortfields">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="sass">
.aoform__shortfields
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  >*
    width: calc(50% - 12.5px)
  @include from(breakpoints.$formMob)
    display: block
    >*
      width: 100%
</style>